import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeItemNameCommand extends BaseCommand {
  CommandName = "ChangeItemName";
  Command: { TmpId: string; Value: string; Calculate: boolean };
  constructor(sessionId: string, operationId: string, tmpId: string, value: string, calculate: boolean) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, Value: value, Calculate: calculate };
  }
}
